import { useEventbriteUrl } from '@/common/constants/useEventbriteUrl';
import homeStyles from '@/styles/Home.module.css';
import { Typography } from '@eventbrite/marmalade';
import Link from 'next/link';
import styles from './PageDisclaimer.module.scss';

export const PageDisclaimer = ({}) => {
  return (
    <div className={styles.disclaimer}>
      <Typography color="textSecondary">
        This form can find tickets purchased in the United States. For other locations, please{' '}
        <Link
          href={useEventbriteUrl('CONTACT_ORGANIZER_URL')}
          target="_blank"
          passHref
          className={homeStyles.url}
        >
          contact the event organizer
        </Link>
        .
      </Typography>
    </div>
  );
};
